import styled from "@emotion/styled"

export const FlexDiv = styled('div')({
    display: "flex",
    alignItems: "center"
})

export const FlexDivColumn = styled('div')({
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column"
})

export const FlexDivStartCenter = styled('div')({
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    alignItems: "center"
})

export const FlexDivSpace = styled('div')({
    display: "flex",
    justifyContent: "space-between"
})

export const FlexDivCenter = styled('div')({
    display: "flex",
    justifyContent: "center"
})

export const FlexDivAllCenter = styled('div')({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
})

export const FlexDivSpaceCenter = styled('div')({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
})